import LearnerLevelBeginner from './LearnerLevelBeginner'

export default LearnerLevelBeginner
// eslint-disable-next-line import/export
export * from './LearnerLevelBeginner'
